//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import $ from "jquery";

(function() {
  angular.module('curalate').service('HashtagsService', [
    '$http',
    'PromiseService',
    '$state',
    function(
            $http,
            PromiseService,
            $state,
        ) {
      const getBaseUrl = function() {
        return `/api/measure/hashtags${$state.params.hashtag ? `/${$state.params.hashtag}` : ''}`;
      };

      // -----------------------------------------------------
      //    Endpoints for All Hashtags and Single Hashtags
      // -----------------------------------------------------

      // Returns information about tracked hashtags including:
      //  1) cumulative interaction data for the hashtag(s) (for stat bubbles)
      //  2) interaction data broken down into time slices (for the charts)
      //  3) interaction data broken down by hashtag (for summary hashtags table)
      this.getHashtagsAsync = function(params) {
        return PromiseService.processHttpResponse($http.get(getBaseUrl(), { params }));
      };

      // Track new hashtag
      this.addHashtagAsync = function(network, hashtag) {
        const params = { network };
        return PromiseService.processHttpResponse($http.post(getBaseUrl(), { hashtag }, { params }));
      };

      // Untrack hashtag by soft deleting from database
      this.removeHashtagAsync = function(params, hashtag) {
        return PromiseService.processHttpResponse($http.delete(`${getBaseUrl()}/${hashtag}`, { params }));
      };

      // Get hashtag IF it is currently tracked
      this.getTrackedHashtagAsync = function(params) {
        return PromiseService.processHttpResponse($http.get(`${getBaseUrl()}/tracking`, { params }));
      };

      this.searchHashtagsAsync = function(params) {
        // use the normal base url instead of trying to append hashtag from the $state params
        return PromiseService.processHttpResponse($http.get('/api/measure/hashtags/search', { params }));
      };

      // Get media associated with tracked hashtag(s)
      this.getHashtagsActivityAsync = function(params) {
        return PromiseService.processHttpResponse($http.get(`${getBaseUrl()}/activity`, { params }));
      };

      // Get related hashtags by affinity
      this.getHashtagAffinityAsync = function(params) {
        return PromiseService.processHttpResponse($http.get(`${getBaseUrl()}/affinity`, { params }));
      };

      // Get the users who have hashtaged the hashtag.
      this.getHashtagUserAsync = function(params) {
        return PromiseService.processHttpResponse($http.get(`${getBaseUrl()}/users`, { params }));
      };

      // -----------------------------------------------------
      //             Endpoints for CSV Downloads
      // -----------------------------------------------------
      this.getHashtagsSummaryCSVUrl = function(params) {
        const paramString = $.param(params);
        return `${getBaseUrl()}/summary.csv${paramString ? `?${paramString}` : ''}`;
      };

      this.getHashtagsActivityCSVUrl = function(params) {
        const paramString = $.param(params);
        return `${getBaseUrl()}/activity.csv${paramString ? `?${paramString}` : ''}`;
      };

      this.getHashtagAffinityCSVUrl = function(params) {
        const paramString = $.param(params);
        return `${getBaseUrl()}/affinity.csv${paramString ? `?${paramString}` : ''}`;
      };

      this.getHashtagUsersCSVUrl = function(params) {
        const paramString = $.param(params);
        return `${getBaseUrl()}/users.csv${paramString ? `?${paramString}` : ''}`;
      };

      this.getHashtagTrendsCSVUrl = function(params) {
        const paramString = $.param(params);
        return `${getBaseUrl()}/trends.csv${paramString ? `?${paramString}` : ''}`;
      };
    }]);
})();
